export default {"src":"/assessments/student/_next/static/media/logo-em.1a9dc6dc.svg","height":28,"width":70,"blurWidth":0,"blurHeight":0};